import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type ShiftNameType } from "@src/appV2/redesign/PlacementCandidate/types";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format, parse } from "date-fns";

interface ShiftTimesDisplayProps {
  shiftType: ShiftNameType;
  shiftTimes: Array<{ startTime?: string; endTime?: string }>;
}

function formatTimeString(timeString: string | undefined): string {
  if (!isDefined(timeString)) {
    return "";
  }

  const timeFormats = ["HH:mm:ss", "HH:mm"];
  const referenceDate = new Date();

  for (const timeFormat of timeFormats) {
    try {
      const parsedTime = parse(timeString, timeFormat, referenceDate);
      return format(parsedTime, "h:mm a");
    } catch {
      continue;
    }
  }

  return "";
}

export function ShiftTimesDisplay(props: ShiftTimesDisplayProps) {
  const { shiftType, shiftTimes } = props;

  return (
    <Stack spacing={1} alignItems="flex-start">
      {shiftTimes.map((shiftTime) => {
        const formattedStartTime = formatTimeString(shiftTime.startTime);
        const formattedEndTime = formatTimeString(shiftTime.endTime);

        if (!formattedStartTime && !formattedEndTime) {
          return null;
        }

        return (
          <Text
            key={`${shiftType}-${shiftTime.startTime ?? ""}-${shiftTime.endTime ?? ""}`}
            semibold
            variant="body2"
            color={(theme) => theme.palette.text.primary}
          >
            {formattedStartTime && formattedEndTime
              ? `${formattedStartTime} - ${formattedEndTime}`
              : (formattedStartTime ?? formattedEndTime)}
          </Text>
        );
      })}
    </Stack>
  );
}
